import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { asapScheduler, finalize, Observable } from "rxjs";
import { LoadingData } from "src/app/cevi-shared/cevi-http-interceptor";


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private loadingData: LoadingData){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        asapScheduler.schedule(()=>{
            this.loadingData.incrSubj.next();
        })
        return next.handle(req).pipe(
            finalize(()=>{
                asapScheduler.schedule(()=>{
                    this.loadingData.decrSubj.next();
                });
            })
        );
    }

}